import type { ServiceProvider, Vendor } from '@shopgnd/shared';
import type { BusinessMode } from '@shopgnd/shared';
import { islandListingUrlParishSlug } from '@shopgnd/shared';
import { proBusinessSlug } from '@/lib/proVendorShell';

export type BusinessProfileTabParam = BusinessMode | 'about' | 'reviews';

export type BusinessPathVendor = Pick<Vendor, 'slug'> & {
  pickupParish?: string | null;
};

/** Canonical public business profile (dependencies: /grenada/carriacou/business/{slug}/). */
export function businessPath(vendor: BusinessPathVendor, tab?: BusinessProfileTabParam): string {
  const parishSlug = islandListingUrlParishSlug(vendor.pickupParish);
  const base = parishSlug
    ? `/grenada/${parishSlug}/business/${encodeURIComponent(vendor.slug)}/`
    : `/grenada/business/${encodeURIComponent(vendor.slug)}/`;
  if (!tab) return base;
  return `${base}?tab=${encodeURIComponent(tab)}`;
}

/** Canonical public profile for a standalone service pro. */
export function proBusinessPath(
  pro: Pick<ServiceProvider, 'id'> & { parish?: string | null },
  tab: BusinessProfileTabParam = 'hire',
): string {
  return businessPath({ slug: proBusinessSlug(pro), pickupParish: pro.parish }, tab);
}

/** Prefer vendor SEO slug when a linked storefront exists. */
export function canonicalBusinessPath(
  vendor: Pick<Vendor, 'id' | 'slug'> | null | undefined,
  pro: Pick<ServiceProvider, 'id'> | null | undefined,
  tab?: BusinessProfileTabParam,
): string {
  if (vendor?.slug && !vendor.id.startsWith('hire-')) {
    return businessPath(vendor, tab);
  }
  if (pro) return proBusinessPath(pro, tab ?? 'hire');
  if (vendor?.slug) return businessPath(vendor, tab);
  return '/grenada/vendors/';
}

/** @deprecated Use businessPath — kept for gradual migration. */
export function vendorStorePath(vendor: Pick<Vendor, 'slug'>): string {
  return businessPath(vendor, 'shop');
}
